var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"bb-table-body-checkbox"},[_c('checkbox',{attrs:{"name":_vm.name,"disabled":_vm.disable,"value":_vm.value},on:{"checkboxChange":_vm.checkboxChange}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4af8a98e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableSoA/Columns/IncludeInGeneralExpenses.vue
// module id = null
// module chunks = 